<div class="relative inline-block">
  <a class="text-blueGray-700 hover:text-blueGray-900 block cursor-pointer select-none" (click)="toggleDropdown($event); $event.stopPropagation()">
    <div class="items-center flex gap-2">
      <span class="w-10 h-10 text-sm text-white bg-blueGray-200 inline-flex items-center justify-center rounded-full flex-shrink-0">
        <img *ngIf="user?.photoURL"
          class="relative inline-block h-10 w-10 rounded-full bg-blueGray-300 object-cover object-center"
          [src]="user?.photoURL" [alt]="user?.name | initials" />
        <div *ngIf="!user?.photoURL"
          class="bg-primary-100 text-primary-500 align-middle cursor-pointer text-base flex justify-center items-center text-center h-10 w-10 rounded-full">
          {{user?.name | initials}}
        </div>
      </span>
      <div class="hidden md:flex items-center gap-1.5 text-sm font-medium text-blueGray-700">
        <span>Welcome, {{ user?.name }}</span>
        <i class="fas fa-chevron-down text-xs text-blueGray-500"></i>
      </div>
    </div>
  </a>
  <div
    class="absolute right-0 top-full mt-1 min-w-48 z-50 bg-white text-base p-1 list-none text-left rounded-md shadow-lg {{ dropdownPopoverShow ? 'block' : 'hidden'}}">
    <a [routerLink]="['profile']"
      class="hover:bg-gray-100 cursor-pointer active:border-none text-sm py-2 px-4 font-normal block w-full whitespace-nowrap bg-transparent text-blueGray-700">
      <i class="fas fa-user mr-2 leading-relaxed"></i>
      My Profile
    </a>
    <a (click)="signOut()"
      class="hover:bg-pink-100 hover:text-red-500 cursor-pointer active:border-none text-sm py-2 px-4 font-normal block w-full whitespace-nowrap bg-transparent text-blueGray-700">
      <i class="fas fa-sign-out-alt mr-2 text-red-500 leading-relaxed"></i>
      Sign Out
    </a>
  </div>
</div>